<template>
  <div class="container-a">
    <div class="m1 m-card"><maplocation :header="'Warehouse Location'" /></div>
    <div class="t1 m-card">
      <tablediv :header="'Active Assets'" />
    </div>
    <div class="t2 m-card">
      <tablediv :header="'Active Assets'" />
    </div>
    <div class="d1">
      <div class="a1 m-card">
        <warehouse
          :header="'Warehouse 01'"
          :detail="'อาคารพร้อมพันธุ์ 1 ชั้น 5 Lat Phrao Rd, Chom Phon, Chatuchak, Bangkok 10900'"
        />
      </div>
      <div class="a2 m-card"><statuscheack :header="'Activity'" /></div>
    </div>
    <div class="d2">
      <div class="a3 m-card">
        <warehouse
          :header="'Warehouse 02'"
          :detail="'อาคารพร้อมพันธุ์ 1 ชั้น 5 Lat Phrao Rd, Chom Phon, Chatuchak, Bangkok 10900'"
        />
      </div>
      <div class="a4 m-card"><statuscheack :header="'Activity'" /></div>
    </div>
  </div>
</template>

<script>
import warehouse from "./components/div_warehouse.vue";
import statuscheack from "./components/div_check.vue";
import maplocation from "./components/map.vue";
import tablediv from "./components/tableActiveAssets.vue";
export default {
  components: { warehouse, maplocation, statuscheack, tablediv },
  data() {
    return {};
  },
};
</script>

<style scoped>
.container-a {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 0.5fr auto;
  grid-auto-rows: 1fr;
  gap: 10px 10px;
  grid-auto-flow: row;
  grid-template-areas:
    "m1 m1"
    "d1 d2"
    "t1 t2";
}
.m-card {
  justify-content: center;
}
.m1 {
  grid-area: m1;
}

.t1 {
  grid-area: t1;
}

.t2 {
  grid-area: t2;
}

.d1 {
  display: grid;
  grid-template-columns: 1.5fr 1fr;
  grid-template-rows: 1fr;
  gap: 10px 10px;
  grid-auto-flow: row;
  grid-template-areas: "a1 a2";
  grid-area: d1;
}

.a1 {
  grid-area: a1;
}

.a2 {
  grid-area: a2;
}

.d2 {
  display: grid;
  grid-template-columns: 1.5fr 1fr;
  grid-template-rows: 1fr;
  gap: 10px 10px;
  grid-auto-flow: row;
  grid-template-areas: "a3 a4";
  grid-area: d2;
}

.a3 {
  grid-area: a3;
}

.a4 {
  grid-area: a4;
}
@media only screen and (max-width: 700px) {
  .container-a {
    grid-template-columns: 100%;
    grid-template-rows: auto;
    grid-auto-rows: 1fr;
    grid-auto-flow: row;
    grid-template-areas:
      "m1"
      "d1"
      "t1"
      "d2"
      "t2";
  }
  .d1 {
    /* display: grid; */
    grid-template-columns: 100%;
    grid-template-rows: auto;
    /* gap: 10px 10px; */
    grid-auto-flow: row;
    grid-template-areas: "a1" "a2";
    /* grid-area: d1; */
  }
   .d2 {
    /* display: grid; */
    grid-template-columns: 100%;
    grid-template-rows: auto;
    /* gap: 10px 10px; */
    grid-auto-flow: row;
    grid-template-areas: "a3" "a4";
    /* grid-area: d1; */
  }
}
</style>